<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-form inline v-if="editable">
      <el-form-item label="关键字">
        <el-input type="text" v-model="keyword"></el-input>
      </el-form-item>
      <el-button type="primary">查询</el-button>
    </el-form>
    <baidu-map class="map" :center="center" :zoom="14" :scroll-wheel-zoom="true" @click="onClick">
      <bm-marker :position="point" :dragging="editable" @dragend="onDrag"></bm-marker>
      <bm-local-search :keyword="keyword" :auto-viewport="true" :panel="false"></bm-local-search>
    </baidu-map>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
      <el-button type="primary" @click="confirm" v-if="editable">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  props: {
    lng: {
      required: true,
      default: 112
    },
    lat: {
      required: true,
      default: 23
    },
    editable: {
      default: false
    }
  },
  data() {
    return {
      center: {
        lng: this.lng,
        lat: this.lat
      },
      point: {
        lng: this.lng,
        lat: this.lat
      },
      keyword: ''
    }
  },
  created() {
  },
  methods: {
    onClick(e) {
      if(this.editable) {
        this.point.lng = e.point.lng;
        this.point.lat = e.point.lat;
      }
    },
    close(){
      this.$emit("close");
    },
    confirm(){
      this.$emit("change", this.point);
    },
    onDrag(e){
      this.point = e.point;
    }
  }
}
</script>
<style lang="scss" scoped>
.map{
  width: 100%;
  height: 60vh;
}
</style>